import React from 'react';
import PropTypes from 'prop-types';

export const PaginationItem = ({ children, page, onClick, active, disabled, className }) => {
    const itemClass = `${disabled ? 'disabled' : ''} ${active ? 'active' : ''} ${className}`;
    return (
        <li className={`page-item ${itemClass}`}>
            <span onClick={onClick} className="page-link">
                {children ? children : page}
            </span>
        </li>
    );
};

PaginationItem.propTypes = {
    page: PropTypes.number,
    size: PropTypes.number,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func
};

PaginationItem.defaultProps = {
    className: '',
    active: false,
    disabled: false
};
